import { BUTTON_OUTLINE } from "../Button/Button.styles";
import { useStylesHook } from "../hooks/useStylesHook";
import { TMS_THEME } from "../theming/theming";
import { DISABLED_CURSOR } from "./utils";
const ICON_HEIGHT = 22;
export const CONTENT_LABEL = {
    fontSize: 11,
    fontWeight: "500 !important",
};
export function useSelectionAreaClasses({ last, first, hasIcon, }) {
    return useStylesHook({
        selectionAreaGroup: {
            display: "flex",
            flexDirection: "row",
        },
        selectionArea: {
            flex: 1,
            height: hasIcon ? ICON_HEIGHT + 68 : 68,
            color: TMS_THEME.palette.gray.slate.color,
            backgroundColor: TMS_THEME.palette.gray.mist.color,
            borderTopLeftRadius: first ? TMS_THEME.root.borderRadius : 0,
            borderBottomLeftRadius: first ? TMS_THEME.root.borderRadius : 0,
            borderTopRightRadius: last ? TMS_THEME.root.borderRadius : 0,
            borderBottomRightRadius: last ? TMS_THEME.root.borderRadius : 0,
            borderColor: TMS_THEME.palette.gray.smoke.color,
            borderLeftWidth: 1,
            borderTopWidth: 1,
            borderRightWidth: last ? 1 : 0,
            borderBottomWidth: 1,
            borderStyle: "solid",
            minWidth: hasIcon ? ICON_HEIGHT + 54 : 54,
            position: "relative",
            "&:focus-within": BUTTON_OUTLINE,
            "&:focus": BUTTON_OUTLINE,
            "&:hover": {
                color: TMS_THEME.palette.gray.fog.contrast,
                backgroundColor: TMS_THEME.palette.gray.fog.color,
            },
        },
        selectionAreaChecked: {
            color: TMS_THEME.palette.gray.fog.contrast,
            backgroundColor: TMS_THEME.palette.gray.fog.color,
        },
        selectionAreaCheckedDisabled: {
            color: TMS_THEME.palette.gray.slate.color,
            backgroundColor: TMS_THEME.palette.gray.mist.color,
        },
        selectionAreaDisabled: {
            "&:hover": {
                color: TMS_THEME.palette.gray.slate.color,
                backgroundColor: TMS_THEME.palette.gray.mist.color,
            },
            opacity: 0.7,
            cursor: DISABLED_CURSOR,
        },
        selectionLabel: {
            flex: 1,
            minHeight: 56,
            fontStyle: "normal",
            textTransform: "uppercase",
            width: "100%",
            cursor: "pointer",
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            marginBottom: "0px !important",
        },
        selectionLabelDisabled: {
            cursor: DISABLED_CURSOR,
        },
        contentBlock: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            minHeight: hasIcon ? ICON_HEIGHT + 38 : 38,
            padding: "10px 10px 0 10px",
            width: "100%",
            ...CONTENT_LABEL,
        },
    });
}
